export { default } from "./ClassesTable";
